import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0B00OutputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { KYMW0B00Model } from '../../../commons/kymw0b/kymw0b00/kymw0b00.model';
import { KYMW0C00OutputModel } from '../../../commons/kymw0c/kymw0c00/vo/kymw0c00-output.model';
import { KYMW0E00OutputModel } from '../../../commons/kymw0e/kymw0e00/vo/kymw0e00-output.model';
import { KYMW1407Model } from './kymw1407.model';
import { KYMW1407InputModel } from './vo/kymw1407-input.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

import { KYMW0B00Component } from '../../../commons/kymw0b/kymw0b00/kymw0b00.component';
import { KYMW0C00Component } from '../../../commons/kymw0c/kymw0c00/kymw0c00.component';
import { KYMW0E00Component } from '../../../commons/kymw0e/kymw0e00/kymw0e00.component';
import { KYMW1407UseImageComponent } from './kymw1407-use-image/kymw1407-use-image.component';
import { KYMW1407SearchResultComponent } from './kymw1407-search-result/kymw1407-search-result.component';
import { KYMW1407ImageInfoDetailBoxComponent } from './kymw1407-image-info-detail-box/kymw1407-image-info-detail-box.component';
import { KYMW1407ImageInfoDetailComponent } from './kymw1407-image-info-detail/kymw1407-image-info-detail.component';

import { GetImageFileUrlService } from './api-services/get-image-file-url.service';
import { GetImageInfoDetailService } from './api-services/get-image-info-detail.service';
import { GetImageListService } from './api-services/get-image-list.service';
import { GetSearchImageListService } from './api-services/get-search-image-list.service';
import { GetUseRecordImageListService } from './api-services/get-use-record-image-list.service';
import { GetUseRecordListService } from './api-services/get-use-record-list.service';
import { RegistUseImageService } from './api-services/regist-use-image.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { UpdateImageInfoEnabledService } from './api-services/update-image-info-enabled.service';
import { UpdateUseImageService } from './api-services/update-use-image.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

/**
 * 画像指示画面を管理するクラス
 *
 * @export KYMW1407Component
 * @class KYMW1407Component
 */
@Component({
  selector: 'app-kymw1407',
  templateUrl: 'kymw1407.component.html',
  styleUrls: ['kymw1407.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1407Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('vw_UseImage', { static: true }) vw_UseImage: KYMW1407UseImageComponent;
  @ViewChild('vw_SearchResult', { static: true }) vw_SearchResult: KYMW1407SearchResultComponent;
  @ViewChild('vw_ImageInfoDetail', { static: true }) vw_ImageInfoDetail: KYMW1407ImageInfoDetailComponent;

  public setKYMW1407Parameter: Function = null;
  public closeFunction: Function = null;
  public kymw1407Model: KYMW1407Model = new KYMW1407Model();
  public kymw0B00Model: KYMW0B00Model = new KYMW0B00Model();

  // コンテキストメニュー
  public useImageMenu: Menu = null;
  public goodsImageMenu: Menu = null;
  public useHistoryMenu: Menu = null;
  public searchImageMenu: Menu = null;

  /**
   * Creates an instance of KYMW1407Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ElementRef} elementRef
   * @param {KYMW00Model} kymw00Model
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {GetImageFileUrlService} getImageFileUrlService
   * @param {GetImageInfoDetailService} getImageInfoDetailService
   * @param {GetImageListService} getImageListService
   * @param {GetSearchImageListService} getSearchImageListService
   * @param {GetUseRecordImageListService} getUseRecordImageListService
   * @param {GetUseRecordListService} getUseRecordListService
   * @param {RegistUseImageService} registUseImageService
   * @param {UpdateImageInfoService} updateImageInfoService
   * @param {UpdateImageInfoEnabledService} updateImageInfoEnabledService
   * @param {UpdateUseImageService} updateUseImageService
   * @memberof KYMW1407Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public chRef: ChangeDetectorRef,
    private elementRef: ElementRef,
    private kymw00Model: KYMW00Model,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getImageFileUrlService: GetImageFileUrlService,
    private getImageInfoDetailService: GetImageInfoDetailService,
    private getImageListService: GetImageListService,
    private getSearchImageListService: GetSearchImageListService,
    private getUseRecordImageListService: GetUseRecordImageListService,
    private getUseRecordListService: GetUseRecordListService,
    private registUseImageService: RegistUseImageService,
    private updateImageInfoService: UpdateImageInfoService,
    private updateImageInfoEnabledService: UpdateImageInfoEnabledService,
    private updateUseImageService: UpdateUseImageService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1407Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1407';
    this.kymw1407Model.kymw1407Component = this;
    // コンテキストメニュー設定
    this.setContextMenu();
  }

  /**
   * コンテキストメニューを追加
   *
   * @memberof KYMW1404Component
   */
  setContextMenu(): void {
    // 使用画像
    this.useImageMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '指示解除', cmd: 'item1', disabled: true },
          { caption: '-' },
          { caption: '前へ', cmd: 'item2', disabled: true },
          { caption: '後ろへ', cmd: 'item3', disabled: true },
          { caption: '先頭へ', cmd: 'item4', disabled: true },
          { caption: '最後へ', cmd: 'item5', disabled: true },
          { caption: '-' },
          { caption: '画像作成指示', cmd: 'item6', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.useImageMenu.selectedValue) {
            case 'item1':
              this.eventUseImageITEM1Change_MENU_SELECTHandler();
              break;
            case 'item2':
              this.eventUseImageITEM2Change_MENU_SELECTHandler();
              break;
            case 'item3':
              this.eventUseImageITEM3Change_MENU_SELECTHandler();
              break;
            case 'item4':
              this.eventUseImageITEM4Change_MENU_SELECTHandler();
              break;
            case 'item5':
              this.eventUseImageITEM5Change_MENU_SELECTHandler();
              break;
            case 'item6':
              this.eventUseImageITEM6Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 商品画像
    this.goodsImageMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '使用指示', cmd: 'item1', disabled: true },
          { caption: '画像保存', cmd: 'item2', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.goodsImageMenu.selectedValue) {
            case 'item1':
              this.eventGoodsImageITEM1Change_MENU_SELECTHandler();
              break;
            case 'item2':
              this.eventGoodsImageITEM2Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 使用履歴
    this.useHistoryMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '使用指示', cmd: 'item1', disabled: true },
          { caption: '画像保存', cmd: 'item2', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.useHistoryMenu.selectedValue) {
            case 'item1':
              this.eventUseHistoryITEM1Change_MENU_SELECTHandler();
              break;
            case 'item2':
              this.eventUseHistoryITEM2Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 検索画像
    this.searchImageMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '使用指示', cmd: 'item1', disabled: true },
          { caption: '画像保存', cmd: 'item2', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.searchImageMenu.selectedValue) {
            case 'item1':
              this.eventSearchImageITEM1Change_MENU_SELECTHandler();
              break;
            case 'item2':
              this.eventSearchImageITEM2Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理 (使用画像)
    this.vw_UseImage.hli_UseImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.useImageMenu !== undefined) {
        this.useImageMenu.show(e);
      }
    });

    // 右クリック押下時 コンテキストメニュー表示処理 (商品画像)
    this.vw_SearchResult.hli_GoodsImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.goodsImageMenu !== undefined) {
        this.goodsImageMenu.show(e);
      }
    });

    // 右クリック押下時 コンテキストメニュー表示処理 (使用履歴)
    this.vw_SearchResult.hli_UseHistoryImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.useHistoryMenu !== undefined) {
        this.useHistoryMenu.show(e);
      }
    });

    // 右クリック押下時 コンテキストメニュー表示処理 (検索結果)
    this.vw_SearchResult.hli_SearchImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.searchImageMenu !== undefined) {
        this.searchImageMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    // 使用画像
    this.initForcedEnabledForContextMenuItemByScreenMode('指示解除', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('前へ', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('後ろへ', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('先頭へ', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('最後へ', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('画像作成指示', 'true');

    // 商品画像
    this.initForcedEnabledForContextMenuItemByScreenMode('使用指示', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('画像保存', 'true');

    // 使用履歴
    this.initForcedEnabledForContextMenuItemByScreenMode('使用指示', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('画像保存', 'true');

    // 検索結果
    this.initForcedEnabledForContextMenuItemByScreenMode('使用指示', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('画像保存', 'true');
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1400Component
   */
  public getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (item) => {
        return !item.disabled;
      }
    };
  }

  /**
   * コンテキストメニュー指示解除ボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseImageITEM1Change_MENU_SELECTHandler(): void {
    this.kymw1407Model.deleteSelectedUseImage();

    // イベント発行
    this.dispatcherUpdateUseImageEvent();

    // コンテキストメニュー更新
    this.kymw1407Model.updateContextMenuEnabled();
  }

  /**
   * コンテキストメニュー前へボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseImageITEM2Change_MENU_SELECTHandler(): void {
    this.kymw1407Model.moveFrontSelectedUseImage();

    // イベント発行
    this.dispatcherUpdateUseImageEvent();
  }

  /**
   * コンテキストメニュー後ろへボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseImageITEM3Change_MENU_SELECTHandler(): void {
    this.kymw1407Model.moveNextSelectedUseImage();

    // イベント発行
    this.dispatcherUpdateUseImageEvent();
  }

  /**
   * コンテキストメニュー先頭へボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseImageITEM4Change_MENU_SELECTHandler(): void {
    this.kymw1407Model.moveFirstSelectedUseImage();

    // イベント発行
    this.dispatcherUpdateUseImageEvent();
  }

  /**
   * コンテキストメニュー最後へボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseImageITEM5Change_MENU_SELECTHandler(): void {
    this.kymw1407Model.moveLastSelectedUseImage();

    // イベント発行
    this.dispatcherUpdateUseImageEvent();
  }

  /**
   * コンテキストメニュー画像作成指示へボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseImageITEM6Change_MENU_SELECTHandler(): void {
    // 画像作成指示画面を呼び出す
    const componentRef = this.dialogService.openModal(KYMW0C00Component);
    const instance = componentRef.componentInstance as KYMW0C00Component;
    instance.setInterfaceParam(this.kymw1407Model.getKYMW0C00InputVO());
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * コンテキストメニュー使用指示ボタン押下イベント
   *
   * @private
   * @returns {void}
   * @memberof KYMW1407Component
   */
  public eventGoodsImageITEM1Change_MENU_SELECTHandler(): void {
    // 画像名(Pコード + 画像種別)から画像種別を抽出
    const txtImageName: string = this.kymw1407Model.selectedImageData.ImageName;
    const txtImageType: string = txtImageName.substring(8, 9);

    // 画像種別のチェック
    // 「F：裏面」の場合
    if (txtImageType === 'F') {
      this.dialogService.openAlertGetMessage('E0207', ['選択された画像', '裏面画像', '使用指示']);
      return;
    }

    // チェック処理
    if (this.kymw1407Model.isExistImageIdInUseImageList(this.kymw1407Model.selectedImageData.ImageId)) {
      this.dialogService.openAlertGetMessage('E0229');
      return;
    }

    this.kymw1407Model.moveSelectedGoodsImageToUseImage();

    //  イベント発行
    this.dispatcherRegistUseImageEvent();

    // コンテキストメニュー更新
    this.kymw1407Model.updateContextMenuEnabled();
  }

  /**
   * コンテキストメニュー画像保存ボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventGoodsImageITEM2Change_MENU_SELECTHandler(): void {
    // 画像保存イベント発行
    this.dispatcherGetImageFileUrlEvent();
  }

  /**
   * コンテキストメニュー使用指示ボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseHistoryITEM1Change_MENU_SELECTHandler(): void {
    // 画像名(Pコード + 画像種別)から画像種別を抽出
    const txtImageName: string = this.kymw1407Model.selectedImageData.ImageName;
    const txtImageType: string = txtImageName.substring(8, 9);

    // 画像種別のチェック
    // 「F：裏面」の場合
    if (txtImageType === 'F') {
      this.dialogService.openAlertGetMessage('E0207', ['選択された画像', '裏面画像', '使用指示']);
      return;
    }

    // チェック処理
    if (this.kymw1407Model.isExistImageIdInUseImageList(this.kymw1407Model.selectedImageData.ImageId)) {
      this.dialogService.openAlertGetMessage('E0229');
      return;
    }

    this.kymw1407Model.moveSelectedUseHistoryImageToUseImage();

    //  イベント発行
    this.dispatcherRegistUseImageEvent();

    // コンテキストメニュー更新
    this.kymw1407Model.updateContextMenuEnabled();
  }

  /**
   * コンテキストメニュー画像保存ボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventUseHistoryITEM2Change_MENU_SELECTHandler(): void {
    // 画像保存イベント発行
    this.dispatcherGetImageFileUrlEvent();
  }

  /**
   * コンテキストメニュー使用指示ボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventSearchImageITEM1Change_MENU_SELECTHandler(): void {
    // 画像名(Pコード + 画像種別)から画像種別を抽出
    const txtImageName: string = this.kymw1407Model.selectedImageData.ImageName;
    const txtImageType: string = txtImageName.substring(8, 9);

    // 画像種別のチェック
    // 「F：裏面」の場合
    if (txtImageType === 'F') {
      this.dialogService.openAlertGetMessage('E0207', ['選択された画像', '裏面画像', '使用指示']);
      return;
    }

    // チェック処理
    if (this.kymw1407Model.isExistImageIdInUseImageList(this.kymw1407Model.selectedImageData.ImageId)) {
      this.dialogService.openAlertGetMessage('E0229');
      return;
    }

    this.kymw1407Model.moveSelectedSearchImageToUseImage();

    //  イベント発行
    this.dispatcherRegistUseImageEvent();

    // コンテキストメニュー更新
    this.kymw1407Model.updateContextMenuEnabled();
  }

  /**
   * コンテキストメニュー画像保存ボタン押下イベント
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventSearchImageITEM2Change_MENU_SELECTHandler(): void {
    // 画像保存イベント発行
    this.dispatcherGetImageFileUrlEvent();
  }

  /**
   * パラメータ設定
   *
   * @memberof KYMW1407Component
   */
  public inputParameterSetting(): void {
    this.procInputVO(this.iInputVOArray);
  }

  /**
   * パラメータ設定
   *
   * @param {KYMW1407InputModel} inputVO
   * @memberof KYMW1407Component
   */
  public setInputVO(inputVO: KYMW1407InputModel): void {
    this.procInputVO(inputVO);
  }

  /**
   * インプットVO処理を行う
   *
   * @private
   * @param {KYMW1407InputModel} inputVO
   * @memberof KYMW1407Component
   */
  private procInputVO(inputVO: KYMW1407InputModel): void {
    const vo: KYMW1407InputModel = inputVO;

    if (!PlessViewUtilsSub.isEmpty(vo.komaId)) {
      if (vo.komaId === this.kymw1407Model.selectedKomaId && this.kymw1407Model.selectedImageData != null) {
        this.setKYMW1407InputVO(vo);
        this.dispatcherGetImageInfoDetailEvent();
      } else {
        this.setKYMW1407InputVO(vo);
        this.dispatcherGetImageListEvent();
      }

      if (vo.goodsCount !== 0) {
        this.kymw1407Model.otherGoodsCount = '他 ' + String(vo.goodsCount - 1) + '点 ';
      } else {
        this.kymw1407Model.otherGoodsCount = '';
      }
    } else {
      this.setKYMW1407InputVO(vo);
      this.kymw1407Model.clear();
      this.kymw1407Model.procViewEnable();
    }
    this.kymw1407Model.updateContextMenuEnabled();
  }

  /**
   * KYMW1407InputVOの内容をマネージャーに設定する
   *
   * @private
   * @param {KYMW1407InputModel} vo
   * @memberof KYMW1407Component
   */
  private setKYMW1407InputVO(vo: KYMW1407InputModel): void {
    this.kymw1407Model.selectedKomaId = vo.komaId;
    this.kymw1407Model.selectedOrderCode = vo.orderCode;
    this.kymw1407Model.selectedCoopCode = vo.coopCode;
    this.kymw1407Model.editMode = vo.editMode;
  }

  /**
   * 開始受注コードバインド
   *
   * @param {string} orderCode
   * @memberof KYMW1407Component
   */
  public bindStartOrderCodeTextInputSelectedOrderCode(orderCode: string): void {
    if (!PlessViewUtilsSub.isEmpty(orderCode) && this.imageInfoDetailBox.cmb_EndOrderCode2.nativeElement.selectedIndex === 2) {
      this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(orderCode);
      this.imageInfoDetailBox.endOrderCode1 = orderCode;
    }
  }

  /**
   * 終了開始受注コードコンボボックスバインド
   *
   * @param {number} index
   * @memberof KYMW1407Component
   */
  public bindEndOrderCodeComboBox(index: string): void {
    if (Number(index) === 0) {
      this.imageInfoDetailBox.disabledEndOrderCode1 = false;
      this.imageInfoDetailBox.readonlyEndOrderCode1 = false;
    } else if (Number(index) === 1) {
      this.imageInfoDetailBox.disabledEndOrderCode1 = true;
      this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode('');
      this.imageInfoDetailBox.endOrderCode1 = '';
    } else if (Number(index) === 2) {
      this.imageInfoDetailBox.disabledEndOrderCode1 = false;
      this.imageInfoDetailBox.readonlyEndOrderCode1 = true;

      if (!PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode)) {
        this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
        this.imageInfoDetailBox.endOrderCode1 = this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode;
      } else {
        this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode('');
        this.imageInfoDetailBox.endOrderCode1 = '';
      }
    }
  }

  /**
   * 終了ボタンイベント
   *
   * @memberof KYMW1407Component
   */
  public eventBtnClose_CLICKHandler(): void {
    if (this.kymw1407Model.imageInfoDetailChangeFlg) {
      this.dialogService.openAlertGetMessage(
        'Q0110',
        null,
        (closeDetail) => {
          this.eventBtnClose_CLICKHandlerClose(closeDetail);
        });
    } else {
      this.kymw0B00Model = new KYMW0B00Model();
      this.closeFunction();
    }
  }

  /**
   * 終了ボタンイベントアラートクローズイベント
   *
   * @private
   * @param {number} closeDetail メッセージ回答
   * @memberof KYMW1407Component
   */
  private eventBtnClose_CLICKHandlerClose(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      this.kymw0B00Model = new KYMW0B00Model();
      this.closeFunction();
    }
  }

  /**
   * 【使用画像】画像クリック
   *
   * @param {*} event ListEvent
   * @memberof KYMW1407Component
   */
  public eventUseImageList_ITEMCLICKHandler(event: any): void {
    this.commonEventImageList_ITEMCLICKHandler(
      event.useImageList,
      event.index,
      (closeDetail) => {
        this.eventUseImageList_ITEMCLICKHandlerClose(closeDetail, event.useImageGroups);
      },
      event.useImageGroups);
  }

  /**
   * 【使用画像】画像クリッククローズイベント
   *
   * @private
   * @param {number} closeDetail メッセージ回答
   * @memberof KYMW1407Component
   */
  private eventUseImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(closeDetail, imageGroups, this.kymw1407Model.getUseImageListSelectedImageIndex());
  }

  /**
   * 【商品画像】画像クリック
   *
   * @param {*} event ListEvent
   * @memberof KYMW1407Component
   */
  public eventGoodsImageList_ITEMCLICKHandler(event: any): void {
    this.commonEventImageList_ITEMCLICKHandler(
      event.goodsImageList,
      event.index,
      (closeDetail) => {
        this.eventGoodsImageList_ITEMCLICKHandlerClose(closeDetail, event.goodsImageGroups);
      },
      event.goodsImageGroups);
  }

  /**
   * 【商品画像】画像クリッククローズイベント
   *
   * @private
   * @param {number} closeDetail メッセージ回答
   * @memberof KYMW1407Component
   */
  private eventGoodsImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(closeDetail, imageGroups, this.kymw1407Model.getGoodsImageListSelectedImageIndex());
  }

  /**
   * 【履歴画像】画像クリック
   *
   * @param {*} event ListEvent
   * @memberof KYMW1407Component
   */
  public eventUseHistoryImageList_ITEMCLICKHandler(event: any): void {
    this.commonEventImageList_ITEMCLICKHandler(
      event.useHistoryImageList,
      event.index,
      (closeDetail) => {
        this.eventUseHistoryImageList_ITEMCLICKHandlerClose(closeDetail, event.useHistoryImageGroups);
      },
      event.useHistoryImageGroups);
  }

  /**
   * 【履歴画像】画像クリッククローズイベント
   *
   * @private
   * @param {number} closeDetail メッセージ回答
   * @memberof KYMW1407Component
   */
  private eventUseHistoryImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(closeDetail, imageGroups,
      this.kymw1407Model.getUseHistoryImageListSelectedImageIndex());
  }

  /**
   * 【検索結果】画像クリック
   *
   * @param {*} event ListEvent
   * @memberof KYMW1407Component
   */
  public eventSearchImageList_ITEMCLICKHandler(event: any): void {
    this.commonEventImageList_ITEMCLICKHandler(
      event.searchImageList,
      event.index,
      (closeDetail) => {
        this.eventSearchImageList_ITEMCLICKHandlerClose(closeDetail, event.searchImageGroups);
      },
      event.searchImageGroups);
  }

  /**
   * 【検索結果】画像クリッククローズイベント
   *
   * @private
   * @param {number} closeDetail メッセージ回答
   * @memberof KYMW1407Component
   */
  private eventSearchImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(closeDetail, imageGroups, this.kymw1407Model.getSearchImageListSelectedImageIndex());
  }

  /**
   * イベント選択共通イベントHandler
   *
   * @private
   * @param {Array<any>} imageList
   * @param {number} index
   * @param {Function} closeFunction
   * @param {HTMLElement} imageGroups
   * @returns {void}
   * @memberof KYMW1407Component
   */
  public commonEventImageList_ITEMCLICKHandler(imageList: Array<any>, index: number,
    closeFunction: Function, imageGroups: HTMLElement): void {
    this.kymw1407Model.selectedImageExistFlg = index >= 0;
    if (index < 0) {
      this.kymw1407Model.updateContextMenuEnabled();
      return;
    }

    // 同一イメージID調査
    if (this.kymw1407Model.selectedImageData != null &&
      this.kymw1407Model.selectedImageData.ImageId === imageList[index].ImageId) {
      this.kymw1407Model.updateContextMenuEnabled();
    } else {
      // 仮イメージID設定
      this.kymw1407Model.tempSelectedImageData = imageList[index];

      // 変更フラグチェック
      if (this.kymw1407Model.imageInfoDetailChangeFlg) {
        this.dialogService.openAlertGetMessage(
          'Q0107',
          ['画像情報詳細'],
          (closeDetail) => {
            closeFunction(closeDetail, imageGroups);
          });
      } else {
        this.kymw1407Model.selectedImageData = this.kymw1407Model.tempSelectedImageData;
        this.dispatcherGetImageInfoDetailEvent();
      }

      this.kymw1407Model.updateContextMenuEnabled();
    }

    // 画像の背景色設定
    this.setImageBackColor(imageGroups, index);
  }

  /**
   * 画像の背景色を設定する
   *
   * @private
   * @param {HTMLElement} imageGroups
   * @param {number} index
   * @memberof KYMW1407Component
   */
  private setImageBackColor(imageGroups: HTMLElement, index: number) {
    // 全ての画像グループの背景色をもとに戻す
    for (let i = Number(0); i < this.vw_UseImage.useImageGroups.nativeElement.children.length; i++) {
      this.vw_UseImage.useImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    for (let i = Number(0); i < this.vw_SearchResult.goodsImageGroups.nativeElement.children.length; i++) {
      this.vw_SearchResult.goodsImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    for (let i = Number(0); i < this.vw_SearchResult.useHistoryImageGroups.nativeElement.children.length; i++) {
      this.vw_SearchResult.useHistoryImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    for (let i = Number(0); i < this.vw_SearchResult.searchImageGroups.nativeElement.children.length; i++) {
      this.vw_SearchResult.searchImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    // 選択した画像の背景色を設定
    imageGroups.children[index].classList.add('image-selected');
  }

  /**
   * イベント選択共通イベントHandlerクローズ
   *
   * @private
   * @param {number} closeDetail
   * @param {ElementRef} imageList
   * @param {number} rollBackSelectedImageIndex
   * @memberof KYMW1407Component
   */
  private commonEventImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement,
    rollBackSelectedImageIndex: number): void {
    if (closeDetail === PlessAlert.Yes) {
      this.kymw1407Model.imageInfoDetailChangeFlg = false;
      this.kymw1407Model.selectedImageData = this.kymw1407Model.tempSelectedImageData;
      this.dispatcherGetImageInfoDetailEvent();
    } else {
      this.setImageBackColor(imageGroups, rollBackSelectedImageIndex);
    }
  }

  /**
   * Pコードリスト変更イベント
   *
   * @param {Event} event
   * @memberof KYMW1407Component
   */
  public eventPcodeList_CHANGEHandler(event: Event): void {
    // 使用履歴一覧を取得する
    this.dispatcherGetUseRecordListEvent();
  }

  /**
   * 【画像リスト】検索ボタン
   *
   * @memberof KYMW1407Component
   */
  public eventBtnSearch_CLICKHandler(): void {
    // 画像検索画面を呼び出す
    const componentRef = this.dialogService.openModal(KYMW0B00Component);
    const instance = componentRef.componentInstance as KYMW0B00Component;
    instance.kymw0B00Model = this.kymw0B00Model;
    instance.setInterfaceParam(this.kymw1407Model.getKYMW0B00InputVO());
    instance.setKYMW0B00Parameter = (kymw0B00OutputModel: KYMW0B00OutputModel) => {
      this.setKYMW0B00Parameter(kymw0B00OutputModel);
    };
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【画像詳細】設定ボタン
   *
   * @memberof KYMW1407Component
   */
  public eventSetting_CLICKHandler(): void {
    // チェック処理を行う
    this.dialogService.openAlertGetMessage(
      'Q0108',
      ['画像情報'],
      (closeDetail) => {
        this.eventSettingClickHandlerClose(closeDetail);
      }
    );
  }

  /**
   * 設定ボタンクリッククローズイベント
   *
   * @private
   * @param {number} closeDetail
   * @returns {void}
   * @memberof KYMW1407Component
   */
  private eventSettingClickHandlerClose(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // 「使用開始受注コード」が未設定の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.startOrderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['使用開始受注コード']);
        return;
      }

      // 「使用開始受注コード」の存在チェック(isValidOrderCode)を行い、
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode)) {
        this.dialogService.openAlertGetMessage('W0024', ['使用開始受注コード']);
        return;
      }

      // 「使用終了受注コード（コンボボックス）」が空白で、且つ、「使用終了受注コード(テキスト)」が未設定の場合
      if (Number(this.imageInfoDetailBox.endOrderCode2) === 0 &&
        PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.endOrderCode1)) {
        this.dialogService.openAlertGetMessage('W0001', ['使用終了受注コード']);
        return;
      }

      // 「使用終了受注コード（テキスト）」が設定されている場合、存在チェック(isValidOrderCode)を行い、処理結果がFalseの場合、
      if (Number(this.imageInfoDetailBox.endOrderCode2) === 0 &&
        PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode)) {
        this.dialogService.openAlertGetMessage('W0024', ['使用終了受注コード']);
        return;
      }

      // 「使用開始受注コード」　と 「使用終了受注コード（テキスト）」が共に設定されている場合、「使用開始受注コード」　≦ 「使用終了受注コード（テキスト）」　の相関チェックを行い、　エラーの場合
      if (!PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode) &&
        !PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode)) {
        if (Number(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode) >
          Number(this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode)) {
          this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
          return;
        }
      }

      // 「撮影予定日」が未設定の場合、以下のメッセージを表示して処理を終了する。
      if (this.imageInfoDetailBox.photoSchedule == null) {
        this.dialogService.openAlertGetMessage('E0110', ['撮影予定日']);
        return;
      }

      // 「撮影場所」が未設定の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.cmb_PhotoStudioId.selectedStudioId)) {
        this.dialogService.openAlertGetMessage('W0001', ['撮影場所']);
        return;
      }

      // ①画像種別が「調理イメージ」の場合で、「調理指示」が未選択の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.nullToBlank(this.kymw1407Model.imageType) === 'C' &&
        PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.cmb_ProcessInstruct.selectedCodeValue)) {
        this.dialogService.openAlertGetMessage('E0103', ['調理指示']);
        return;
      }

      // 「優先度」が未設定の場合、'5' で補正する。
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.priority)) {
        this.imageInfoDetailBox.priority = '5';
      }

      // 『使用ページ確認画面』の「使用画像チェック処理」を行う。
      const componentRef = this.dialogService.openModal(KYMW0E00Component);
      const instance = componentRef.componentInstance as KYMW0E00Component;
      instance.setInterfaceParam(this.kymw1407Model.getKYMW0E00InputVO(1));
      instance.parent = this;
      instance.setKYMW0E00Parameter = (outputVO: KYMW0E00OutputModel) => {
        this.setKYMW0E00Parameter(outputVO);
      };
      instance.closeFunction = () => {
        componentRef.close();
      };
    }
  }

  /**
   * 【画像詳細】リセットボタン
   *
   * @private
   * @memberof KYMW1407Component
   */
  public eventReset_CLICKHandler(): void {
    this.dispatcherGetImageInfoDetailEvent();
  }

  /**
   * 【画像詳細】使用停止ボタン
   *
   * @memberof KYMW1407Component
   */
  public eventUseStop_CLICKHandler(): void {
    this.dialogService.openAlertGetMessage(
      'Q0126',
      null,
      (closeDetail) => {
        this.eventUseStop_CLICKHandlerClose(closeDetail);
      });
  }

  /**
   * 【画像詳細】使用停止ボタンアラートクローズイベント
   *
   * @private
   * @param {number} closeDetail メッセージ回答
   * @memberof KYMW1407Component
   */
  private eventUseStop_CLICKHandlerClose(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // 『使用ページ確認画面』の「使用画像チェック処理」を行う。
      const componentRef = this.dialogService.openModal(KYMW0E00Component);
      const instance = componentRef.componentInstance as KYMW0E00Component;
      instance.setInterfaceParam(this.kymw1407Model.getKYMW0E00InputVO(2));
      instance.parent = this;
      instance.setKYMW0E00Parameter = (outputVO: KYMW0E00OutputModel) => {
        this.setKYMW0E00Parameter(outputVO);
      };
      instance.closeFunction = () => {
        componentRef.close();
      };
    }
  }

  /**
   * 使用履歴データグリッド選択イベント
   *
   * @param {Event} event
   * @memberof KYMW1407Component
   */
  public eventPcodeInfoList_CLICKHandler(event: Event): void {
    if (!this.kymw1407Model.flag && this.vw_SearchResult.dgv_PcodeInfoList.selection.row === 0) {
      this.kymw1407Model.flag = true;
    } else if (this.kymw1407Model.flag && this.vw_SearchResult.dgv_PcodeInfoList.selection.row > -1) {
      this.dispatcherGetUseRecordImageListEvent();
    }
  }

  /**
   * 商品詳細情報変更イベント
   *
   * @param {Event} event
   * @memberof KYMW1407Component
   */
  public eventImageInfoDetailCHANGEHandler(event: Event): void {
    this.kymw1407Model.imageInfoDetailChangeFlg = true;
    this.bindStartOrderCodeTextInputSelectedOrderCode(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
  }

  /**
   * 商品詳細情報開始受注コード変更イベント
   *
   * @param {Event} event
   * @memberof KYMW1407Component
   */
  public eventImageInfoDetailStartOrderCodeCHANGEHandler(event: string): void {
    if (event !== this.kymw1407Model.startOrderCodeOrigin) {
      this.kymw1407Model.imageInfoDetailChangeFlg = true;
    }
    this.bindStartOrderCodeTextInputSelectedOrderCode(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
  }

  /**
   * 商品詳細情報終了受注コード変更イベント
   *
   * @param {Event} event
   * @memberof KYMW1407Component
   */
  public eventImageInfoDetailEndOrderCodeCHANGEHandler(event: string): void {
    if (event !== this.kymw1407Model.endOrderCode1Origin) {
      this.kymw1407Model.imageInfoDetailChangeFlg = true;
    }
    this.bindStartOrderCodeTextInputSelectedOrderCode(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
  }

  /**
   * 画像情報イベント発行
   *
   * @memberof KYMW1407Component
   */
  public dispatcherGetImageListEvent(): void {
    const vo = this.kymw1407Model.getGetImageListVO();
    this.getImageListService.execute(this.kymw1407Model, vo);
  }

  /**
   * 画像詳細情報取得イベント発行
   *
   * @private
   * @memberof KYMW1407Component
   */
  private dispatcherGetImageInfoDetailEvent(): void {
    const vo = this.kymw1407Model.getGetImageInfoDetailVO();
    this.getImageInfoDetailService.execute(this.kymw1407Model, vo);
  }

  /**
   * 画像詳細情報取得イベント発行
   *
   * @private
   * @memberof KYMW1407Component
   */
  private dispatcherGetImageFileUrlEvent(): void {
    const vo = this.kymw1407Model.getGetImageFileUrlVO();
    this.getImageFileUrlService.execute(vo, this.fileDownloadConfirmService);
  }

  /**
   * 使用画像更新イベント発行
   *
   * @private
   * @memberof KYMW1407Component
   */
  private dispatcherUpdateUseImageEvent(): void {
    const vo = this.kymw1407Model.getUpdateUseImageVO();
    this.updateUseImageService.execute(this.kymw1407Model, vo);
  }

  /**
   * 使用画像登録イベント発行
   *
   * @private
   * @memberof KYMW1407Component
   */
  private dispatcherRegistUseImageEvent(): void {
    const vo = this.kymw1407Model.getRegistUseImageVO();
    this.registUseImageService.execute(this.kymw1407Model, vo);
  }

  /**
   * 使用履歴一覧取得イベント発行
   *
   * @private
   * @memberof KYMW1407Component
   */
  private dispatcherGetUseRecordListEvent(): void {
    const vo = this.kymw1407Model.getGetUseRecordListVO();
    this.getUseRecordListService.execute(this.kymw1407Model, vo);
  }

  /**
   * 使用履歴画像リスト取得イベント発行
   *
   * @private
   * @memberof KYMW1407Component
   */
  private dispatcherGetUseRecordImageListEvent(): void {
    const vo = this.kymw1407Model.getGetUseRecordImageListVO();
    this.getUseRecordImageListService.execute(this.kymw1407Model, vo);
  }

  /**
   * 検索画像リスト取得イベント発行
   *
   * @private
   * @param {KYMW0B00OutputModel} outputVO
   * @memberof KYMW1407Component
   */
  public dispatcherGetSearchImageListEvent(outputVO: KYMW0B00OutputModel): void {
    const vo = this.kymw1407Model.getGetSearchImageListVO(outputVO);
    this.getSearchImageListService.execute(this.kymw1407Model, vo);
  }

  /*------------------------------------------------------------------------------------------
  - get プロパティ
  -----------------------------------*/
  /**
   * 画像詳細情報VBOX取得
   *
   * @readonly
   * @type {KYMW1407ImageInfoDetailBoxComponent}
   * @memberof KYMW1407Component
   */
  public get imageInfoDetailBox(): KYMW1407ImageInfoDetailBoxComponent {
    return this.vw_ImageInfoDetail.imageInfoDetailBox;
  }

  /*------------------------------------------------------------------------------------------
  - 子画面連携
  -----------------------------------*/
  /**
   * 検索条件を設定する
   *
   * @param {KYMW0B00OutputModel} outputVO
   * @memberof KYMW1407Component
   */
  public setKYMW0B00Parameter(outputVO: KYMW0B00OutputModel): void {
    this.dispatcherGetSearchImageListEvent(outputVO);
  }

  /**
   * 結果を返却する
   *
   * @param {KYMW0C00OutputModel} outputVO
   * @memberof KYMW1407Component
   */
  public setKYMW0C00Parameter(outputVO: KYMW0C00OutputModel): void {
  }

  /**
   * 結果を返却する
   *
   * @param {KYMW0E00OutputModel} outputVO
   * @returns {void}
   * @memberof KYMW1407Component
   */
  public setKYMW0E00Parameter(outputVO: KYMW0E00OutputModel): void {
    // キャンセルの場合
    if (outputVO.changeButton === 2) {
      return;
    }

    let vo: any = new Object();
    switch (outputVO.processDiv) {
      case 1:	// 使用範囲変更時
        vo = this.kymw1407Model.getUpdateImageInfoVO();
        this.updateImageInfoService.execute(this.kymw1407Model, vo);
        break;

      case 2:	// 使用停止時
        vo = this.kymw1407Model.getUpdateImageInfoEnabledVO();
        this.updateImageInfoEnabledService.execute(this.kymw1407Model, vo);
        break;
    }
  }

  /**
   * ｢コマ割｣画面の再表示処理を行う。
   *
   * @memberof KYMW1407Component
   */
  public refreshKYMW1400(): void {
    // 親画面に返却する
    this.setKYMW1407Parameter();
  }

}
